import { render, staticRenderFns } from "./HeaderMenuReportPanel.vue?vue&type=template&id=b8f70f7e&scoped=true&"
import script from "./HeaderMenuReportPanel.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuReportPanel.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenuReportPanel.vue?vue&type=style&index=0&id=b8f70f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f70f7e",
  null
  
)

export default component.exports